import { DateInput, Form, RadioGroup, TextField } from "@/base";
import { CalendarDate } from "@internationalized/date";
import type { SubmitHandler, UseFormReturn } from "react-hook-form";
import type { Resume } from "../types";

interface ResumeStep1FormProps {
    id?: string;
    formController: UseFormReturn<Resume>;
    onSubmit: SubmitHandler<Resume>;
    onPreview?: () => void;
}

export const ResumeStep1Form = ({
    id,
    formController,
    onSubmit,
}: ResumeStep1FormProps) => {
    return (
        <Form
            id={id}
            controller={formController}
            onSubmit={onSubmit}
            className="flex flex-col gap-6"
        >
            <TextField<Resume>
                fieldName="name"
                label="Vor- und Nachname (ggf. auch Mittelname)"
                isRequired={true}
                size="lg"
            />
            <TextField<Resume>
                fieldName="email"
                label="E-Mail"
                type="email"
                isRequired={true}
                size="lg"
            />
            <TextField<Resume>
                fieldName="phone"
                label="Telefon"
                type="tel"
                isRequired={true}
                size="lg"
            />

            <TextField<Resume>
                fieldName="street"
                label="Straße & Hausnummer"
                isRequired={true}
                className="col-span-5"
                size="lg"
            />

            <div className="grid grid-cols-7 gap-2">
                <TextField<Resume>
                    fieldName="postalCode"
                    label="PLZ"
                    isRequired={true}
                    className="col-span-2"
                    size="lg"
                />
                <TextField<Resume>
                    fieldName="city"
                    label="Stadt"
                    isRequired={true}
                    className="col-span-5"
                    size="lg"
                />
            </div>

            <DateInput<Resume>
                fieldName="birthDate"
                label="Geburtsdatum"
                isFullWidth={true}
                className="col-span-2 xs:col-span-7 sm:col-span-3"
                size="lg"
                minValue={new CalendarDate(1950, 1, 1)}
            />

            <div className="grid grid-cols-7 gap-x-2 gap-y-6">
                <RadioGroup<Resume>
                    fieldName="status"
                    options={[
                        { label: "Ledig", value: "single" },
                        { label: "Verheiratet", value: "married" },
                    ]}
                    orientation="vertical"
                    className="col-span-2"
                />
                <TextField<Resume>
                    fieldName="numberOfChildren"
                    label="Anzahl Kinder"
                    type="number"
                    precision={0}
                    className="col-span-5"
                    autoComplete="new-children-count"
                    size="lg"
                    min={0}
                    max={20}
                />
            </div>
        </Form>
    );
};
